
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"fill-rule":"evenodd","clip-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"1.5"},style,staticStyle],
              attrs: Object.assign({"width":"100%","height":"100%","viewBox":"0 0 500 500","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","xml:space":"preserve","xmlns:serif":"http://www.serif.com/","style":"fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('path',{staticStyle:{"fill":"none","stroke":"#19cf86","stroke-width":"30px"},attrs:{"d":"M458.416,264.045c22.691,85.77 -28.347,173.927 -114.108,196.906c-27.249,7.301 -54.752,7.152 -80.342,0.802c40.888,-39.394 59.718,-99.253 43.995,-157.934c-11.115,-41.482 13.539,-84.184 55.022,-95.299c41.482,-11.115 84.184,13.539 95.299,55.021l0.134,0.504Z"}}),_c('path',{staticStyle:{"fill":"none","stroke":"#19cf86","stroke-width":"30px"},attrs:{"d":"M170.155,80.336c62.934,-62.536 164.799,-62.414 227.58,0.368c19.948,19.948 33.57,43.841 40.866,69.177c-54.561,-15.713 -115.815,-2.091 -158.773,40.866c-30.367,30.367 -79.675,30.367 -110.042,0c-30.367,-30.367 -30.367,-79.676 0,-110.043l0.369,-0.368Z"}}),_c('path',{staticStyle:{"fill":"none","stroke":"#19cf86","stroke-width":"30px"},attrs:{"d":"M155.189,421.832c-85.625,-23.234 -136.451,-111.513 -113.471,-197.274c7.301,-27.249 21.182,-50.993 39.476,-69.979c13.673,55.108 56.096,101.344 114.777,117.068c41.482,11.115 66.136,53.817 55.021,95.3c-11.115,41.482 -53.817,66.136 -95.3,55.021l-0.503,-0.136Z"}})])])
          )
        }
      }
    